module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/24_db0542f4aec4127240d0314f513b62fe.jpg";